import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import ServiceLineReport from './ServiceLineReport';
import ProcedureReport from './ProcedureReport';
import HospitalReports from './HospitalReports';
import Dashboard from './Dashboard';
import MedicationAdherence from './MedicationAdherence';
import PatientRiskStatus from './PatientRiskStatus';
import PatientVitalTabSettings from './PatientVitalTabSettings';
import PatientDashBoardTable from './PatientDashBoardTable';
import JeevaSessionTabSettings from './JeevaSessionTabSettings';
import ErrorBoundary from '../../ErrorBoundary';
import PatientMedication from './PatientMedication';
import MedicationTimeOfDay from './MedicationTimeOfDay';
import MedicationDaysOfWeek from './MedicationDaysOfWeek';
import ViewSurvey from './ViewSurvey';
import DashBoardJournalStatus from './DashBoardJournalStatus';

class ReportsTabSettings extends Component {
    constructor() {
        super();
        this.state = {
            showHomeEnityName: localStorage.getItem("homeEntityName"),
            patientAdmissionHeading: ''
        }
        window.reportsNavBarController = this;
    }
    componentDidMount() {
        this.paintPatientAdmissionHeading();
        if (!this.tabClickHandlerDefined) {
            this.tabClickHandlerDefined = true;
            $("#patients,#procedure,#service-line,#hospital,#medication-adherence,#patient-risk-status,#view-survey")
                .on("click", function () {
                    $("#patients,#procedure,#service-line,#hospital,#medication-adherence,#patient-risk-status,#view-survey")
                        .removeClass('active');
                    localStorage.setItem("reports-nav-bar-selection", $(this)[0].id);
                    $(this).addClass('active')
                });
        }
        this.markActiveTab();

    }

    markActiveTab() {
        $("#patients,#procedure,#service-line,#hospital,#medication-adherence,#reports,#view-survey").removeClass('active');
        var defaultSelection = false;
        var savedNavBarSelection = localStorage.getItem("reports-nav-bar-selection");
        var currentPath = window.location.href;
        if (currentPath.includes('/projectmgmt/reports/service-lines') || currentPath.includes('/projectmgmt/reports/service-lines/')) {
            defaultSelection = "service-line";
        } else if (currentPath.includes('/projectmgmt/reports/procedures') || currentPath.includes('/projectmgmt/reports/procedures/')) {
            defaultSelection = "procedure";
        } else if (currentPath.includes('/projectmgmt/reports/hospitals') || currentPath.includes('/projectmgmt/reports/hospitals/')) {
            defaultSelection = "hospital";
        } else if (currentPath.includes('/projectmgmt/reports/medication-adherence') || currentPath.includes('/projectmgmt/reports/medication-adherence/') 
            || currentPath.includes("/projectmgmt/reports/medication-list") || currentPath.includes("/projectmgmt/reports/medication-list/")
            || currentPath.includes("/projectmgmt/reports/time-of-day") || currentPath.includes("/projectmgmt/reports/time-of-day/") 
            || currentPath.includes("/projectmgmt/reports/days-of-week") || currentPath.includes("/projectmgmt/reports/days-of-week/")) {
            defaultSelection = "medication-adherence";
        }  else if (currentPath.includes('/projectmgmt/reports/jeeva-sessions') || currentPath.includes('/projectmgmt/reports/jeeva-sessions/')) {
            defaultSelection = "patients";
        } else if (currentPath.includes('/projectmgmt/reports/view-survey') || currentPath.includes('/projectmgmt/reports/view-survey/')) {
            defaultSelection = "view-survey";
        } else if (currentPath.includes('/projectmgmt/reports/patient-dashboard') || currentPath.includes('/projectmgmt/reports/patient-dashboard/') 
            || currentPath.includes("/projectmgmt/reports/dashboard-table") || currentPath.includes("/projectmgmt/reports/dashboard-table/")
            || currentPath.includes("/projectmgmt/reports/dashboard-med-adherence") || currentPath.includes("/projectmgmt/reports/dashboard-med-adherence/")
            || currentPath.includes('/projectmgmt/reports') || currentPath.includes('/projectmgmt/reports/') ) {
            defaultSelection = "patient-risk-status";
        } else if (currentPath.includes('/projectmgmt/reports') || currentPath.includes('/projectmgmt/reports/')) {
            defaultSelection = "patients";
        }
        if (defaultSelection !== false) {
            $("#reportsNavMenu #" + defaultSelection).addClass('active');
            localStorage.setItem("reports-nav-bar-selection", defaultSelection);
        } else {
            if (savedNavBarSelection) {
                $("#reportsNavMenu #" + savedNavBarSelection).addClass('active');
            }

        }
    }
    paintPatientAdmissionHeading = () => {
        var healthSystemName = localStorage.getItem('healthSystemName');
        var hospitalName = localStorage.getItem('hospitalName');
        var serviceLineName = localStorage.getItem('serviceName');

        if (healthSystemName == "Select Health System" || healthSystemName == "null") {
            healthSystemName = null;
        }
        if ((hospitalName == "Select Hospital") || (hospitalName == "null")) {
            hospitalName = null;
        }
        if ((serviceLineName == "Select Service Line") || (serviceLineName == "null")) {
            serviceLineName = null;
        }

        var heading = "";
        if (healthSystemName) {
            heading = healthSystemName;
            if (hospitalName) {
                heading = hospitalName + " | " + heading;
                if (serviceLineName) {
                    heading = serviceLineName + " | " + heading;
                }
            }
        }
        this.state.patientAdmissionHeading = heading;
        this.setState(this.state);
    }

    render() {
        this.markActiveTab();
        return (
            <ErrorBoundary>
                <div id="tabPage">
                    <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

                        <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                        <title> Dheeyantra | Clusters Details</title>
                        {/* Font Awesome Icons */}
                        <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                        {/* IonIcons */}
                        <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                        {/* Theme style */}
                        <link rel="stylesheet" href="assets/css/adminlte.css" />
                        <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                        <link rel="stylesheet" href="assets/css/custom-style.css" />
                        <link rel="stylesheet" href="assets/css/styles.css" />
                        <link rel="stylesheet" href="assets/css/custom-style.css" />
                        <div className="content-header" >
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <h1 className="m-0 page-title">Dashboard</h1>
                                    </div>
                                    <div className="col-sm-8" style={{ textAlign: 'right' }}>
                                        <h1 className="m-0 page-title" style={{ textAlign: 'right' }}>
                                            {window.SCOPE_VALUE.CURRENT == 10 ? this.state.patientAdmissionHeading : this.state.showHomeEnityName}

                                        </h1>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="container-fluid" >
                            {/* Nav tabs */}
                            <div className="border-bottom"></div>
                            <div className="tab-class">

                                <ul className="nav nav-tabs border-bottom navCluster" id="reportsNavMenu">
                                    <Link className="nav-item" data-toggle="tab"
                                        to="/projectmgmt/reports" style={{ textDecoration: 'none' }}>
                                        <li className="nav-link" id="patient-risk-status" style={{ marginRight: '15px' }}>
                                            Patient Risk Dashboard
                                        </li></Link>

                                    <Link className="nav-item" data-toggle="tab"
                                        to="/projectmgmt/reports/medication-adherence" style={{ textDecoration: 'none' }}>
                                        <li className="nav-link" id="medication-adherence" style={{ marginRight: '15px' }}>
                                            Patient Medications
                                        </li></Link>
                                    <Link className="nav-item" data-toggle="tab"
                                        to="/projectmgmt/reports/view-survey" style={{ textDecoration: 'none' }}>
                                        <li className="nav-link" id="view-survey" style={{ marginRight: '15px' }}>
                                            View Survey
                                        </li></Link>
                                    <Link className="nav-item" data-toggle="tab"
                                        to="/projectmgmt/reports/jeeva-sessions" style={{ textDecoration: 'none' }}>
                                        <li className="nav-link" id="patients" style={{ marginRight: '15px' }}>
                                        JEEVA AI Agent Sessions
                                        </li></Link>

                                </ul>
                            </div>
                        </div>
                    </div>
                    <Switch>
                        <Route path="/projectmgmt/reports/hospitals" component={HospitalReports}></Route>
                        <Route path="/projectmgmt/reports/service-lines" component={ServiceLineReport}></Route>
                        <Route path="/projectmgmt/reports/procedures" component={ProcedureReport}></Route>
                        <Route path="/projectmgmt/reports/medication-adherence" component={MedicationAdherence}></Route>
                        <Route path="/projectmgmt/reports/jeeva-sessions" component={JeevaSessionTabSettings}></Route>
                        <Route path="/projectmgmt/reports/view-patient-data" component={JeevaSessionTabSettings}></Route>
                        <Route path="/projectmgmt/reports/patient-dashboard" component={PatientVitalTabSettings}></Route>
                        <Route path="/projectmgmt/reports/dashboard-table" component={PatientVitalTabSettings}></Route>
                        <Route path="/projectmgmt/reports/dashboard-med-adherence" component={PatientVitalTabSettings}></Route>
                        <Route path="/projectmgmt/reports/medication-list" component={PatientMedication}></Route>
                        <Route path="/projectmgmt/reports/time-of-day" component={MedicationTimeOfDay}></Route>
                        <Route path="/projectmgmt/reports/days-of-week" component={MedicationDaysOfWeek} ></Route>
                        <Route path="/projectmgmt/reports/view-survey" component={ViewSurvey} ></Route>
                        <Route path="/projectmgmt/reports/dashboard-journal-status" component={PatientVitalTabSettings} ></Route>

                        <Route path="/projectmgmt/reports" component={PatientRiskStatus}></Route>
                    </Switch>
                </div>
            </ErrorBoundary>
        );
    }
}
export default ReportsTabSettings;




// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ReportsTabSettings.js